import { render, staticRenderFns } from "./AbibaroStudentRegistration.vue?vue&type=template&id=dac4d452&scoped=true"
import script from "./AbibaroStudentRegistration.vue?vue&type=script&lang=ts"
export * from "./AbibaroStudentRegistration.vue?vue&type=script&lang=ts"
import style0 from "./AbibaroStudentRegistration.vue?vue&type=style&index=0&id=dac4d452&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dac4d452",
  null
  
)

export default component.exports